module.exports = __webpack_public_path__ + "img/longarrow-right-black.7e912feb.svg";